import React from "react";
import { useSelector } from "react-redux";
import ControlPanelMain from "./Components/UI/ControlPanelMain/ControlPanelMain";
import useDimensions from "./Hooks/useDimensions";
import LoaderCustom from "./Elements/Loader/LoaderCustom";
import Stage from "./Elements/Stage/Stage";
import useWinSound from "./Hooks/useWinSound";
import useReelsController from "./Hooks/useReelsController";
import useKeyboardControls from "./Hooks/useKeyboardControls";
import MainGame from "./Games/MainGame/MainGame";
import FreeSpinGame from "./Games/FreeSpinGame/FreeSpinGame";
import useAnimations from "./Hooks/useAnimations";
import useFreeSpinReelsController from "./Hooks/useFreeSpinReelsController";

const App = () => {
  useWinSound();
  useAnimations();
  useKeyboardControls();
  const { reelRefs, handleSpin, handleManualStop } = useReelsController();
  const { freeSpinReelRefs, handleFreeSpin, handleFreeSpinStop } =
    useFreeSpinReelsController();
  const { dimensions, symbolSize } = useDimensions();
  const { isLoading } = useSelector((state) => state.game);
  const { assetsLoaded } = useSelector((state) => state.assets);

  return (
    <>
      <LoaderCustom hidden={!isLoading} />

      {assetsLoaded && (
        <Stage dimensions={dimensions}>
          <MainGame
            dimensions={dimensions}
            symbolSize={symbolSize}
            reelRefs={reelRefs}
          />

          <FreeSpinGame
            dimensions={dimensions}
            symbolSize={symbolSize}
            freeSpinReelRefs={freeSpinReelRefs}
          />
        </Stage>
      )}

      {!isLoading && (
        <ControlPanelMain
          handleStop={handleManualStop}
          handleSpin={handleSpin}
          handleFreeSpin={handleFreeSpin}
          handleFreeSpinStop={handleFreeSpinStop}
        />
      )}
    </>
  );
};

export default App;
